import { ref } from 'vue';

import { useScrollLock } from './use-scroll-lock';

/**
 * Composable for managing modal state and scroll locking
 * @returns {Object} Modal state and methods
 */
const useModal = () => {
  const { lockScroll, unlockScroll } = useScrollLock();
  const modalStates = ref({});

  /**
   * Checks if a modal is open
   * @param {string} modalId - The ID of the modal to check
   * @returns {boolean} True if the modal is open, false otherwise
   */
  const isModalOpen = (modalId) => {
    return modalStates.value[modalId] === true;
  };

  /**
   * Opens a modal
   * @param {string} modalId - The ID of the modal to open
   */
  const openModal = (modalId) => {
    Object.keys(modalStates.value).forEach((key) => (modalStates.value[key] = false));
    lockScroll();
    modalStates.value[modalId] = true;
  };

  /**
   * Closes a modal
   * @param {string} modalId - The ID of the modal to close
   */
  const closeModal = (modalId) => {
    modalStates.value[modalId] = false;
    unlockScroll();
  };

  return {
    closeModal,
    isModalOpen,
    modalStates,
    openModal,
  };
};

export { useModal };
